module.exports = __webpack_public_path__ + "static/kuning-5978f5da208a487cbffaaec62944442a.png";